<!--响应式用户目录-->
<template>
  <div class="el-dialog__wrapper offcanvas-bar-wrap" v-show="visible" @click.self="handleWrapperClick">
    <div
      aria-modal="true"
      class="offcanvas-bar"
      ref="dialog"
      :style="style">
      <div class="el-dialog__body" v-show="rendered"><slot></slot></div>
    </div>
  </div>
</template>

<script>
  import "~/assets/stylus/offcanvas-bar.styl";
  import Popup from 'element-ui/src/utils/popup';
  import Migrating from 'element-ui/src/mixins/migrating';
  import emitter from 'element-ui/src/mixins/emitter';

  export default {
    name: 'offcanvas-bar',

    mixins: [Popup, emitter, Migrating],

    props: {

      modal: {
        type: Boolean,
        default: true
      },

      potion: {
        type: String,
        default: "left"
      },

      lockScroll: {
        type: Boolean,
        default: false
      },

      closeOnClickModal: {
        type: Boolean,
        default: true
      },

      closeOnPressEscape: {
        type: Boolean,
        default: true
      },

      showClose: {
        type: Boolean,
        default: true
      },

      width: String,

      bgColor: {
        type: String,
        default: "#000"
      },

      fullscreen: Boolean,

      customClass: {
        type: String,
        default: ''
      },

      top: {
        type: String,
        default: '15vh'
      },
      beforeClose: Function,
      center: {
        type: Boolean,
        default: false
      },
    },

    data() {
      return {
        closed: false
      };
    },

    watch: {
      visible(val) {
        if (val) {
          this.closed = false;
          this.$nextTick(() => {
            // this.$refs.dialog.scrollTop = 0;
            this.$emit('open', this);
          });

          // document.body.appendChild(this.$el);

        } else {
          if (!this.closed) this.$emit('close');
        }
      }
    },

    computed: {
      style() {
        let style = {};
        if (this.width) {
          style.width = this.width;
          if (this.potion === "left") {
            style.left = 0;
          } else {
            style.right = 0;
          }
          style.background = this.bgColor;
        }

        return style;
      }
    },

    methods: {
      getMigratingConfig() {
        return {
          props: {
            'size': 'size is removed.'
          }
        };
      },
      handleWrapperClick() {
        if (!this.closeOnClickModal) return;
        this.handleClose();
      },
      handleClose() {
        if (typeof this.beforeClose === 'function') {
          this.beforeClose(this.hide);
        } else {
          this.hide();
        }
      },
      hide(cancel) {
        if (cancel !== false) {
          this.$emit('update:visible', false);
          this.$emit('close');
          this.closed = true;
        }
      },
      afterEnter() {
        this.$emit('opened');
      },
      afterLeave() {
        this.$emit('closed');
      }
    },

    mounted() {
      if (this.visible) {
        this.rendered = true;
        this.open();
        if (this.appendToBody) {
          // document.body.appendChild(this.$el);
        }
      }
    },

    destroyed() {
      // if appendToBody is true, remove DOM node after destroy
      if (this.appendToBody && this.$el && this.$el.parentNode) {
        this.$el.parentNode.removeChild(this.$el);
      }
    }
  };
</script>

<style lang="stylus">
  .el-dialog__body {
    /*padding: 0 !important;*/
  }
  .offcanvas-bar-wrap{
    height: 100vh;
    .el-dialog__body{
      padding-bottom 0;
      height: 100%;
    }
  }
</style>
